import { Box, Button, Card, CardContent, Skeleton, Stack, Typography } from '@mui/material';
import { t } from 'i18next';
import { memo } from 'react';
import { RemediationDetailsSkeleton } from './RemediationDetailsSkeleton';

export const OverviewSkeleton = memo(() => {
  return (
    <Card>
      <CardContent>
        <Stack spacing={3}>
          <Stack direction="row" gap={2} sx={{ alignItems: 'stretch', flexWrap: 'wrap' }}>
            {/* Back button */}
            <Skeleton sx={{ display: { xl: 'none' } }}>
              <Button>{t('back')}</Button>
            </Skeleton>
            {/* Severity badge */}
            <Skeleton height={32} width={40} />
            <Box sx={{ flexGrow: 1 }} />
            {/* Filter status */}
            <Skeleton width={200} />
          </Stack>
          <Typography variant="h3" sx={{ pt: 3, fontSize: '1.75rem' }}>
            {/* Instance name */}
            <Skeleton width="100%" />
            <Skeleton width="40%" />
          </Typography>
          {/* Remediation */}
          <RemediationDetailsSkeleton />
        </Stack>
      </CardContent>
    </Card>
  );
});
